export default __webpack_public_path__ + "static/media/no_attachment_yet.4ca53b4a.png";